export const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3004/becas"
    : "https://api.quimica.unam.mx/bowser/becas";

export function headersTok(data) {
  const { tok, accion } = data;
  return {
    headers: {
      "x-api-key": tok,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": accion,
      "Access-Control-Allow-Headers": "application/json",
      "content-type": "application/json",
    },
  };
}

export function headersST(accion) {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": accion,
      "Access-Control-Allow-Headers": "application/json",
      "content-type": "application/json",
    },
  };
}

export const errorResponse = {
  replyCode: 500,
  replyText: "Error desconocido, contactar a Planeación",
};

export const definido = (value) =>
  value !== undefined && value !== "" && value !== null;

export const arrayDefinido = (value) =>
  Array.isArray(value) && value.length > 0;

export const objetoDefinido = (value) =>
  definido(value) && Object.keys(value).length > 0;
